module.exports = "<p>\n  \"TrakRight Terms and Conditions\"\n</p>\n"